module.exports = __webpack_public_path__ + "static/media/promocodeBulkTemplate.f5b513ba.xlsx";